<template>
    <div class="vx-card px-6 py-2">
        <div class="vx-row">
            <div class="vx-col md:w-1/3 sm:w-1/2 w-full md:mt-0">
                <label class="vs-input--label">Tìm kiếm</label>
                <vs-input class="w-full" v-model="keyword" :placeholder="$t('button.search')"
                          v-on:keyup.enter="filter"/>
            </div>
            <div class="vx-col md:w-1/3 mt-2">
                <vs-button class="mr-2 md:mt-4 sm:mt-8" color="primary" icon-pack="feather"
                           icon="icon-search"
                           @click="filter">Tìm kiếm
                </vs-button>
            </div>
            <div class="vx-col md:w-1/3 mt-2">
                <vs-button class="mr-2 md:mt-4 sm:mt-8 float-right" color="primary" iconPack="feather"
                           icon="icon-plus"
                           @click="$router.push('/user/restricted-keywords-info')">
                    {{ this.$t('menuNewFeed.create') }}
                </vs-button>
            </div>
        </div>
        <!--End Items-->

        <!--Table & Pagination-->
        <div class="vs-row mt-6">
            <!--Table-->
            <ag-grid-vue style="height: 55vh" ref="agGridTable" :gridOptions="gridOptions"
                         class="ag-theme-material w-100 my-4 ag-grid-table" :columnDefs="columnDefs"
                         :defaultColDef="defaultColDef"
                         :rowData="keywordsData" :animateRows="true" :pagination="true"
                         :localeText="{ noRowsToShow: this.$t('menuCustomer.noRowsToShow') }" :onGridReady="onGridReady"
                         :suppressPaginationPanel="true">
            </ag-grid-vue>
            <!--Pagination-->
                        <div class="vx-row" v-if="keywordsData.length > 0">
                            <div class="vx-col sm:w-1/2 w-full">
                                <div class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4 vx-row">
                                    <span class="vx-col mt-2">Số phần tử / trang:</span>
                                    <vs-dropdown vs-trigger-click class="cursor-pointer">
                                        <div
                                            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium vx-col">
                                            <span class="mr-2">
                                                {{
                                                    keywordsData.length - currentPage * pageSize > 0 ? currentPage *
                                                        pageSize
                                                        : keywordsData.length
                                                }} /
                                                {{ totalElements }}</span>
                                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
                                        </div>
                                        <vs-dropdown-menu>
                                            <vs-dropdown-item @click="changePageSize(20)">
                                                <span>20</span>
                                            </vs-dropdown-item>
                                            <vs-dropdown-item @click="changePageSize(30)">
                                                <span>30</span>
                                            </vs-dropdown-item>
                                            <vs-dropdown-item @click="changePageSize(50)">
                                                <span>50</span>
                                            </vs-dropdown-item>
                                            <vs-dropdown-item @click="changePageSize(100)">
                                                <span>100</span>
                                            </vs-dropdown-item>
                                        </vs-dropdown-menu>
                                    </vs-dropdown>
                                </div>
                            </div>
                            <div class="vx-col sm:w-1/2 w-full">
                                <vs-pagination :total="totalPages" v-model="currentPage" @change="loadPage"/>
                            </div>
                        </div>
        </div>
        <!-- End Table & Pagination-->
    </div>
</template>
<script>
import {AgGridVue} from "ag-grid-vue";
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss';
import CellRendererActionsKeyword from "./cell-renderer/CellRendererActionsKeyword";

export default {
    name: "RestrictedKeywordsInfo",
    components: {
        AgGridVue,
        CellRendererActionsKeyword,
    },
    data() {
        return {
            columnDefs: [
                {
                    headerName: 'STT',
                    field: 'stt',
                    maxWidth: 100
                },
                {
                    headerName: this.$t('menuNewFeed.restrictedKeywords'),
                    field: 'keyword',
                    width: 250
                },
                {
                    headerName: this.$t('button.actions'),
                    field: 'actions',
                    width: 100,
                    cellRendererFramework: 'CellRendererActionsKeyword',
                },
            ],
            keywordsData: [],
            gridApi: null,
            gridOptions: {},
            defaultColDef: {},
            pageNumber: 0,
            pageSize: 20,
            totalPages: 0,
            currentPage: 1,
            totalElements: 0,
            keyword: null,
        }
    },

    watch: {
        '$store.state.windowWidth'(val) {
            if (val > 1024) {
                this.gridApi.sizeColumnsToFit();
            }
        },
        '$store.state.reduceButton'() {
            setTimeout(() => {
                this.gridApi.sizeColumnsToFit();
            }, 650);
        },
        '$store.state.isUpdateNewKeywords'(val) {
            if (val) {
                this.getAllKeyword();
                this.$store.commit('UPDATE_NEW_KEYWORDS', false);
            }
        },
    },
    created() {

        this.getAllKeyword();
    },
    methods: {
        getAllKeyword() {
            let payload = {
                id: this.id,
                keyword: this.keyword,
                pageNumber: this.pageNumber,
                pageSize: this.pageSize,
            }
            this.$vs.loading();
            this.$crm.post('/beauty-foul-keyword/find-by-condition', payload).then(res => {
                this.keywordsData = res.data.content.map(el => {
                    el.stt = this.pageSize * this.pageNumber + res.data.content.indexOf(el) + 1;
                    return el;
                })
                this.totalPages = res.data.totalPages;
                this.totalElements = res.data.totalElements;
                this.$vs.loading.close();
            }).catch(err => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            })
        },

        addNewsEvent() {
            this.$router.push('/user/info-news-event')
        },

        onGridReady() {
            if (this.$store.state.windowWidth > 1024) {
                this.gridApi.sizeColumnsToFit();
            }
        },

        loadPage: function (currentPage) {
            if (this.pageNumber !== parseInt(currentPage) - 1) {
                this.pageNumber = parseInt(currentPage) ? parseInt(currentPage) - 1 : 0;
                this.getAllKeyword();
            }
        },

        changePageSize(number) {
            this.pageSize = number;
            this.pageNumber = 0;
            this.currentPage = 1;
            this.getAllKeyword();
        },

        filter() {
            this.currentPage = 1;
            this.pageNumber = 0;
            this.getAllKeyword();
        }
    },
    mounted() {
        this.gridApi = this.gridOptions.api;
    }
}
</script>
